<template>
  <div>
    <template v-if="order.fees.length">
      <p v-for="(fee, i) in order.fees" :key="i">
        <b>{{ $t(fee.description) }}:</b>
        {{ fee.amount | currency(order.currency_label) }}
      </p>
    </template>
    <p>
      <b>{{ $t('orders.total_amount') }}:</b>
      {{ order.amount | currency(order.currency_label) }}
    </p>
    <p v-if="order.amount_paid">
      <b>{{ $t('orders.paid_amount') }}:</b>
      {{ order.amount_paid | currency(order.currency_label) }}
    </p>
    <p v-if="order.amount_refunded">
      <b>{{ $t('orders.refunded_amount') }}:</b>
      {{ order.amount_refunded | currency(order.currency_label) }}
    </p>
    <p v-if="order.last_payment_at">
      <b>{{ $t('orders.last_paid') }}:</b>
      {{ order.last_payment_at | moment($dateFormat) }}
    </p>
    <p v-if="order.completed_at">
      <b>{{ $t('orders.completed_at') }}:</b>
      {{ order.completed_at | moment($dateFormat) }}
    </p>
    <p>
      <b>{{ $t('orders.created_at') }}:</b>
      {{ order.created_at | moment($dateFormat) }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'OrderDetails',

  props: {
    order: { type: Object, required: true },
  },
}
</script>
